import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-statement',
  templateUrl: './privacy-statement.component.html',
  styleUrls: ['./privacy-statement.component.css']
})
export class PrivacyStatementComponent implements OnInit {
  title = 'WorldERP.com Privacy Statement';

  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {property: 'og:title', content: 'WorldERP.com Privacy Statement'},
      {property: 'og:type', content: 'privacy-statement'},
      {property: 'og:url', content: '/privacy-statement'},
      {property: 'og:image', content: ''}
    ]);
  }

}
